import { useState } from "react";
import { Modal, Button, Form, InputGroup } from "react-bootstrap";
import { FaEye, FaEyeSlash, FaUser, FaMobileAlt } from "react-icons/fa";
import { FcGoogle } from "react-icons/fc";
import "./AuthModal.css";
import SignUpModal from "../userAuth/SignUpModal";
import { API_URL } from "../utils/api.js";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../../redux/userSlice";
import { useToast } from "../../context/ToastContext";
import { Link } from "react-router-dom";

export default function LoginModal({ show, handleClose, onHide }) {
  // Fallback — if parent sends onHide instead of handleClose
  const close = handleClose || onHide || (() => { });

  const dispatch = useDispatch();
  const { loading, error: reduxError } = useSelector((state) => state.user);
  const { showToast } = useToast();

  const [useMobile, setUseMobile] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    userId: "",
    mobile: "",
    password: "",
  });
  const [showSignUp, setShowSignUp] = useState(false);

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    // Clear error when user types
    if (errors[e.target.name]) {
      setErrors({ ...errors, [e.target.name]: "" });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (useMobile) {
      if (!formData.mobile) {
        newErrors.mobile = "Mobile number is required";
      } else if (formData.mobile.length !== 10) {
        newErrors.mobile = "Mobile number must be 10 digits";
      }
    } else {
      if (!formData.userId) {
        newErrors.userId = "User ID is required";
      } else if (formData.userId.length < 5) {
        newErrors.userId = "User ID must be at least 5 characters";
      }
    }

    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const payload = useMobile
      ? { mobile: formData.mobile, password: formData.password }
      : { userId: formData.userId, password: formData.password };

    // Dispatch the login action
    const resultAction = await dispatch(loginUser(payload));

    if (loginUser.fulfilled.match(resultAction)) {
      showToast("Login successful 🎉", "success");
      setTimeout(() => {
        close();
      }, 500);
    } else {
      // Handle failure
      showToast(resultAction.payload || "Login failed", "danger");
    }
  };

  const handleGoogleLogin = () => {
    window.location.href = `${API_URL}/users/auth/google`;
  };

  return (
    <>
      <Modal
        show={show}
        onHide={close}
        centered
        scrollable
        size="lg"
        className="auth-modal"
        backdrop="static" // prevents closing when clicking outside
      >
        <Modal.Body className="p-0">
          <div className="login-container position-relative d-flex flex-column flex-md-row">
            {/* LEFT IMAGE SECTION */}
            <div className="login-left d-none d-md-flex w-50">
              <img
                // src="https://i.ibb.co/gMLtTZ0/ipl-2025.png"
                // src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRgH-0j7pDw3YNquJ8HQ6YkIA4iqmVlJRyvVg&s"
                src="/login-register-image.png"
                alt="IPL"
                className="w-100 h-100 object-fit-cover"
              />
            </div>

            {/* RIGHT LOGIN FORM */}
            <div className="login-right">
              {/* Close Button */}
              <button
                className="btn-close-custom"
                onClick={close}
                aria-label="Close"
              >
                &times;
              </button>

              <div className="text-center d-flex gap-2 align-items-center mb-2">
                <h4 className="text-white fw-bold">Login to</h4>
                <h4 className="text-orange fw-bold">Ambe Worlds</h4>
              </div>

              {/* <h5 className="login-title">Sign In</h5> */}

              <div className="auth-tabs">
                <button
                  className={`auth-tab ${!useMobile ? "active" : ""}`}
                  onClick={() => setUseMobile(false)}
                >
                  <FaUser className="me-2" /> User ID
                </button>
                <button
                  className={`auth-tab ${useMobile ? "active" : ""}`}
                  onClick={() => setUseMobile(true)}
                >
                  <FaMobileAlt className="me-2" /> Mobile
                </button>
              </div>

              <Form onSubmit={handleSubmit}>
                {useMobile ? (
                  <Form.Group className="mb-3">
                    <Form.Label>Mobile Number</Form.Label>
                    <InputGroup>
                      <InputGroup.Text className="prefix-text">
                        +91
                      </InputGroup.Text>
                      <Form.Control
                        type="text"
                        name="mobile"
                        placeholder="Enter Mobile Number"
                        value={formData.mobile}
                        onChange={handleChange}
                        isInvalid={!!errors.mobile}
                      />
                    </InputGroup>
                    <Form.Control.Feedback
                      type="invalid"
                      style={{ display: !!errors.mobile ? "block" : "none" }}
                    >
                      {errors.mobile}
                    </Form.Control.Feedback>
                  </Form.Group>
                ) : (
                  <Form.Group className="mb-3">
                    <Form.Label>User Id</Form.Label>
                    <Form.Control
                      type="text"
                      name="userId"
                      placeholder="Enter User Id"
                      value={formData.userId}
                      onChange={handleChange}
                      isInvalid={!!errors.userId}
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.userId}
                    </Form.Control.Feedback>
                  </Form.Group>
                )}

                <Form.Group className="mb-1">
                  <Form.Label>Password</Form.Label>
                  <InputGroup hasValidation>
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Enter Password"
                      value={formData.password}
                      onChange={handleChange}
                      isInvalid={!!errors.password}
                    />
                    <Button
                      variant="outline-secondary"
                      onClick={() => setShowPassword(!showPassword)}
                      className="border-secondary"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </Button>
                    <Form.Control.Feedback type="invalid">
                      {errors.password}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>

                <div className="text-end mb-2">
                  <Link
                    to="/user-reset-pass"
                    className="forgot-link"
                    onClick={() => {
                      handleClose();
                      // setShowSignUp(true);
                    }}
                  >
                    Forgot Password?
                  </Link>
                </div>

                <Button type="submit" className="w-100 sign-btn border-0">
                  Sign In
                </Button>
              </Form>

              <div className="divider-container">
                <div className="divider-line"></div>
                <div className="divider-text">OR</div>
                <div className="divider-line"></div>
              </div>

              <button className="google-btn" onClick={handleGoogleLogin}>
                <FcGoogle size={22} />
                <span>Sign in with Google</span>
              </button>

              <div className="text-center mt-4 small text-secondary">
                New User?{" "}
                <a
                  href="#"
                  className="text-warning fw-bold text-decoration-none"
                  onClick={() => {
                    handleClose();
                    setShowSignUp(true);
                  }}
                >
                  Create an account
                </a>
                <div
                  className="mt-2"
                  style={{ fontSize: "0.8rem", opacity: 0.7 }}
                >
                  <a href="#" className="text-secondary text-decoration-none">
                    Privacy Policy
                  </a>{" "}
                  &bull;{" "}
                  <a href="#" className="text-secondary text-decoration-none">
                    Terms of Service
                  </a>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <SignUpModal show={showSignUp} handleClose={() => setShowSignUp(false)} />
    </>
  );
}
